/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Trained_For_Lt6mInputs */

const en_us2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less than 6 months`)
};

const pt_br2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 6 meses`)
};

const es_419_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 6 meses`)
};

const pt_pt2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menos de 6 meses`)
};

const fr_fr2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moins de 6 mois`)
};

const de_de2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger als 6 Monate`)
};

const it_it2_onboarding_experience_trained_for_lt6m = /** @type {(inputs: Onboarding_Experience_Trained_For_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meno di 6 mesi`)
};

/**
* | output |
* | --- |
* | "Less than 6 months" |
*
* @param {Onboarding_Experience_Trained_For_Lt6mInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_trained_for_lt6m = /** @type {((inputs?: Onboarding_Experience_Trained_For_Lt6mInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Trained_For_Lt6mInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_trained_for_lt6m(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_trained_for_lt6m(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_trained_for_lt6m(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_trained_for_lt6m(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_trained_for_lt6m(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_trained_for_lt6m(inputs)
	return en_us2_onboarding_experience_trained_for_lt6m(inputs)
});
export { onboarding_experience_trained_for_lt6m as "onboarding.experience_trained_for.lt6m" }